export default __webpack_public_path__ + "static/media/play-store-dark.b19d0784.svg";